import {MouseEventHandler} from "react";
import Network from "../../Shared/Util/Network";
import {Answer} from "../../Shared/Model/GameData";

interface QuizAnswerProps {
    answer: Answer,
    onClick : MouseEventHandler,
    selected : boolean
}

export function QuizAnswer(props: QuizAnswerProps) {
    const className = props.selected ? (props.answer.correct ? 'correct' : 'wrong') : undefined

    return <li onClick={props.onClick} className={className}>
        {props.answer.picture !== null && <img src={Network.pictureUrl(props.answer.picture)} alt=""/>}
        <div className="text">{props.answer.text}</div>
    </li>
}